export function setCountryData(state, data) {
  return {
    ...state,
    countryData: {
      ...state.countryData,
      data: data
    }
  };
}

export function setCountryStatus(state, status) {
  return {
    ...state,
    countryData: {
      ...state.countryData,
      status: status
    }
  };
} 